import React from "react";
import Link from "../Link";
import "./ExpandLIRAButton.css"

const ExpandLIRAButton = () => {

    return (
        <Link href="/lira-page">
            <div className="rectangle-6459 border-1px-athens-gray-2">
                <div className="expand-lira-button">
                    <div className="expand-lira-button-5">
                        <div className="lira-text">
                            <div className="lira-text-1 nunito-bold-blue-20px">LIRA</div>
                        </div>
                    </div> 
                </div>
            </div>
        </Link>
    );
}

export default ExpandLIRAButton;